export const sortGroupDrillDownFields = {
  AGENCY_NAME: "AgencyNameAndNo",
  BATCH_NUMBER: "BatchNo",
  PRODUCER_1_NAME: "ProducerName1",
  PRODUCER_2_NAME: "ProducerName2",
  PRODUCER_1_CODE: "ProducerCode1",
  PRODUCER_2_CODE: "ProducerCode2",
  MONTH: "ProdMonthName",
  CITY: "City",
  RATE_CLASS: "RateClass",
  FLEET_GARAGE_NUMBER: "FleetGarageNumber",
  PRODUCT: "Product",
};
export const drillDownSortFieldOptions = (includeFleetGarage) => [
  { label: "Agency", value: sortGroupDrillDownFields.AGENCY_NAME },
  { label: "Month", value: sortGroupDrillDownFields.MONTH },
  { label: "Batch Number", value: sortGroupDrillDownFields.BATCH_NUMBER },
  {
    label: "Fleet/Garage Number",
    value: sortGroupDrillDownFields.FLEET_GARAGE_NUMBER,
    disabled: !includeFleetGarage,
  },
  { label: "City", value: sortGroupDrillDownFields.CITY },
  { label: "Producer 1", value: sortGroupDrillDownFields.PRODUCER_1_CODE },
  { label: "Producer 2", value: sortGroupDrillDownFields.PRODUCER_2_CODE },
  { label: "ICBC Product", value: sortGroupDrillDownFields.PRODUCT },
];

export const salesAndCondensedDrillDownFieldOptions = (includeFleetGarage) => [
  { label: "Agency", value: sortGroupDrillDownFields.AGENCY_NAME },
  { label: "Month", value: sortGroupDrillDownFields.MONTH },
  {
    label: "Fleet/Garage Number",
    value: sortGroupDrillDownFields.FLEET_GARAGE_NUMBER,
    disabled: !includeFleetGarage,
  },
  { label: "City", value: sortGroupDrillDownFields.CITY },
  { label: "Producer 1", value: sortGroupDrillDownFields.PRODUCER_1_CODE },
  { label: "Producer 2", value: sortGroupDrillDownFields.PRODUCER_2_CODE },
  { label: "ICBC Product", value: sortGroupDrillDownFields.PRODUCT },
];

export const comparisonDrillDownFieldOptions = (includeFleetGarage) => [
  { label: "Agency", value: sortGroupDrillDownFields.AGENCY_NAME },
  { label: "Month", value: sortGroupDrillDownFields.MONTH },
  {
    label: "Fleet/Garage Number",
    value: sortGroupDrillDownFields.FLEET_GARAGE_NUMBER,
    disabled: !includeFleetGarage,
  },
  { label: "City", value: sortGroupDrillDownFields.CITY },
  { label: "Producer 1", value: sortGroupDrillDownFields.PRODUCER_1_CODE },
  { label: "Producer 2", value: sortGroupDrillDownFields.PRODUCER_2_CODE },
];

export const sortGroupFieldOptions = (includeFleetGarage) => [
  { label: "Agency", value: sortGroupDrillDownFields.AGENCY_NAME },
  { label: "Month", value: sortGroupDrillDownFields.MONTH },
  { label: "Batch Number", value: sortGroupDrillDownFields.BATCH_NUMBER },
  { label: "Producer 1 Name", value: sortGroupDrillDownFields.PRODUCER_1_NAME },
  { label: "Producer 2 Name", value: sortGroupDrillDownFields.PRODUCER_2_NAME },
  { label: "Producer 1 Code", value: sortGroupDrillDownFields.PRODUCER_1_CODE },
  { label: "Producer 2 Code", value: sortGroupDrillDownFields.PRODUCER_2_CODE },
  {
    label: "Fleet/Garage Number",
    value: sortGroupDrillDownFields.FLEET_GARAGE_NUMBER,
    disabled: !includeFleetGarage,
  },
  { label: "City", value: sortGroupDrillDownFields.CITY },
  { label: "Rate Class", value: sortGroupDrillDownFields.RATE_CLASS },
  { label: "ICBC Product", value: sortGroupDrillDownFields.PRODUCT },
];

export const reportTypes = {
  SUMMARY: "Summary",
  SALES_SUMMARY: "SalesSummary",
  DETAIL: "Detail",
  COMPARISON: "Comparison",
  SUMMARY_CONDENSED: "SummaryCondensed",
  COMPARISON_CONDENSED: "ComparisonCondensed",
};

export const productionReportTypeOptions = [
  { value: reportTypes.SUMMARY, label: "Summary" },
  { value: reportTypes.SALES_SUMMARY, label: "Sales" },
  { value: reportTypes.DETAIL, label: "Detail" },
  { value: reportTypes.COMPARISON, label: "Comparison" },
  { value: reportTypes.SUMMARY_CONDENSED, label: "Summary (Condensed)" },
  { value: reportTypes.COMPARISON_CONDENSED, label: "Comparison (Condensed)" },
];

export const reportDateTypes = {
  TRANSACTION_DATE: 0,
  EXPIRY_DATE: 1,
};
